module.exports = __webpack_public_path__ + "img/Banner.c597711b.jpg";